import { useCallback, useState } from "react";

const useIsHovering = () => {
  const [isHovering, setIsHovering] = useState(false);

  const onMouseOver = useCallback(() => {
    setIsHovering(true);
  }, []);

  const onMouseOut = useCallback(() => {
    setIsHovering(false);
  }, []);

  return {
    isHovering,
    onMouseOver,
    onMouseOut,
  };
};

export default useIsHovering;
